import type { FC } from "react"

const Menu: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="22px"
      height="14px"
      viewBox="0 0 22 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Mobile"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="camp-mobile-landing-page"
          transform="translate(-24.000000, -22.000000)"
          fill="currentColor"
        >
          <g id="Header" transform="translate(-1.000000, -52.000000)">
            <g id="Nav" transform="translate(0.000000, 51.000000)">
              <g id="Group" transform="translate(25.000000, 23.000000)">
                <rect
                  id="Rectangle1"
                  x="0"
                  y="0"
                  width="22"
                  height="2"
                  rx="1"
                ></rect>
                <rect
                  id="Rectangle2"
                  x="0"
                  y="6"
                  width="18"
                  height="2"
                  rx="1"
                ></rect>
                <rect
                  id="Rectangle3"
                  x="0"
                  y="12"
                  width="14"
                  height="2"
                  rx="1"
                ></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Menu
